import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-close",
  "use": "icon-cl-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cl-close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM6.346 7.76A1 1 0 0 1 7.76 6.346l4.24 4.24 4.193-4.194a1 1 0 1 1 1.415 1.414L13.414 12l4.245 4.245a1 1 0 0 1-1.414 1.414L12 13.414l-4.292 4.292a1 1 0 0 1-1.414-1.415L10.586 12l-4.24-4.24Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol